import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-loeschen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungFunktionsbereichLoeschenEffects {

    FunktionsbereichLoeschen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_LOESCHEN),
        mergeMap((x: ac.PostFunktionsbereichLoeschenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichLoeschen(x.funktionsbereichRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichLoeschenErfolgreichAction(result, x.funktionsbereichRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichLoeschenFehlerAction(error, x.funktionsbereichRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
